export default __webpack_public_path__ + "assets/ak-cached/2h/images/verizonup_logo_-_desktop.png";